<template lang="pug">
  form(role="form" @submit.prevent.stop)
    payout-form-group(:label="$t('Тип перевода')" :required="true" :has-errors="model.errors.has('tag')")
      dropdown-keyvalue(:options="tagOptionsKeyValue"
        :placeholder="$t('Выберите тип перевода')"
        v-model="model.values.tag")
    template(v-if="warningEurSha")
      payout-hint-panel-form-group(:warning="true" :heading="$t('Раздельная комиссия (SHA)')")
        i18n(path="warning_eur_sha" tag="span")
          template(v-slot:CUR) <strong>EUR</strong>
          template(v-slot:TAG) <strong>SHA</strong>
    template(v-if="model.values.tag")
      payout-toggable-hint-panel-form-group(:heading="$t('wire_tag.' + model.values.tag)" :link-text="$t('wire_tag.' + model.values.tag)")
        i18n(:path="'wire_tag.description.' + model.values.tag" tag="span")

    payout-form-group
      h3(style="width: 380px; text-align: center;") {{ $t('Получатель') }}
    payout-textfield-input-group(:model="model" :label="$t('Имя получателя')" :required="true" attribute="beneficiary")
    payout-textfield-input-group(:model="model" :label="$t('Адрес получателя')" :required="true" attribute="beneficiaryAddress")
    payout-form-group(:label="$t('Страна')" :required="true" :has-errors="model.errors.has('beneficiaryCountry')")
      payout-form-group-regular-width
        PayoutCountriesDropdown(:show-key-in-name="true"
          :limit="beneficiaryCountryLimit"
          v-model="model.values.beneficiaryCountry")
        //dropdown-keyvalue(:options="beneficiaryAddressCountriesSorted" :placeholder="$t('Выберите страну')"
          v-model="model.values.beneficiaryCountry")
      error-message-block(v-slot:errors attribute="beneficiaryCountry|*" :errors="model.errors")

    payout-form-group
      h3(style="width: 380px; text-align: center;") {{ $t('Банковские реквизиты') }}

    payout-textfield-input-group(:model="model" :label="$t('SWIFT-код банка')" :required="true" attribute="beneficiaryBankSWIFT")
    payout-form-group
      swift-selector(:query="model.values.beneficiaryBankSWIFT" @bank-selected="onBankSelected")

    payout-textfield-input-group(:model="model" :label="$t('Cчет / IBAN получателя')" :required="true" attribute="beneficiaryAccount")
    payout-textfield-input-group(:model="model" :label="$t('Название банка получателя')" :required="true" attribute="beneficiaryBankName")
    payout-textfield-input-group(:model="model" :label="$t('Адрес банка получателя')" :required="true" attribute="beneficiaryBankAddress")
    payout-form-group(:label="$t('Страна банка')" :required="true" :has-errors="model.errors.has('beneficiaryBankCountry')")
      payout-form-group-regular-width
        PayoutCountriesDropdown(:show-key-in-name="true"  v-model="model.values.beneficiaryBankCountry")
        //dropdown-keyvalue(:options="bankAddressCountriesSorted" :placeholder="$t('Выберите страну')"
          v-model="model.values.beneficiaryBankCountry")
      error-message-block(v-slot:errors attribute="beneficiaryBankCountry|*" :errors="model.errors")

    template(v-if="model.values.correspondentBank")
      hr
    template(v-else)
      br
    payout-form-group-section-checkbox(:label="$t('Банк-корреспондент')" v-model="model.values.correspondentBank" )
    template(v-if="model.values.correspondentBank")
      payout-textfield-input-group(:model="model" :label="$t('SWIFT-код банка')" :required="true" attribute="correspondentBankSWIFT")
      payout-form-group
        swift-selector(:query="model.values.correspondentBankSWIFT" @bank-selected="onCorrBankSelected")
      payout-textfield-input-group(:model="model" :label="$t('Название банка')" :required="true" attribute="correspondentBankName")
      payout-textfield-input-group(:model="model" :label="$t('Адрес банка')" :required="true" attribute="correspondentBankAddress")
      payout-form-group(:label="$t('Страна Банка')" :required="true" :has-errors="model.errors.has('correspondentBankCountry')")
        dropdown-keyvalue(:options="bankAddressCountriesSorted" :placeholder="$t('Выберите страну')"
          v-model="model.values.correspondentBankCountry")
        error-message-block(v-slot:errors attribute="correspondentBankCountry|*" :errors="model.errors")

      payout-textfield-input-group(:model="model" :label="$t('Корр. счет')" :required="true" attribute="correspondentAccount")
      hr
    br

    payout-textfield-input-group(:model="model" :label="$t('Назначение')"
      :hint="$t('description_hint')"
      :required="true" attribute="description")

    payout-input-amount-form-group(:model="model")
    payout-evaluate-fee-form-group(:model="model")

    // Будет применен курс автоконвертации ({src} = {dest})
    // payout-destination-currency-conversion-notice-form-group(:model="model")
    // Ожидаемая сумма зачисления
    payout-estimated-destination-amount-form-group(:model="model")

    //template(v-if="model.options.limitsTextHtml")
      payout-toggable-hint-panel-form-group(:heading="$t('Лимиты')" :link-text="$t('Информация о лимитах')")
        div(v-html="model.options.limitsTextHtml")


    payout-form-notification-block(:model="model")

    hr

    payout-group-verification-type(:model="model")
</template>

<script lang="ts">
import {computed, defineComponent, getCurrentInstance, reactive, ref, watch} from "vue";
import AbstractPayoutForm from "@/components/forms/payout/abstract/AbstractPayoutForm.vue";
import {WirePaymentModel, WireTagEnum} from "@/components/forms/payout/forms/wire/payout-wire";
import PayoutFormGroup from "@/components/forms/payout/PayoutFormGroup.vue";
import DropdownKeyvalue from "@/components/forms/dropdown/DropdownKeyValue.vue";
import {CurrencyCode} from "@/models/core/currency";
import VueI18n from "vue-i18n";
import PayoutToggableHintPanel from "@/components/forms/payout/PayoutToggableHintPanel.vue";
import PayoutHintPanelFormGroup from "@/components/forms/payout/hint/PayoutHintPanelFormGroup.vue";
import PayoutToggableHintPanelFormGroup
  from "@/components/forms/payout/hint/PayoutToggableHintPanelFormGroup.vue";
import PayoutTextfieldInputGroup from "@/components/forms/payout/PayoutTextfieldInputGroup.vue";
import ErrorMessageBlock from "@/components/forms/payout/ErrorMessageBlock.vue";
import SwiftSelector from "@/components/payout/SwiftSelector.vue";
import PayoutFormGroupSectionCheckbox
  from "@/components/forms/payout/formgroup/PayoutFormGroupSectionCheckbox.vue";
import PayoutFormNotificationBlock
  from "@/components/forms/payout/forms/PayoutFormNotificationBlock.vue";
import PayoutGroupVerificationType
  from "@/components/payout/verification/PayoutGroupVerificationType.vue";
import PayoutEstimatedDestinationAmountFormGroup
  from "@/components/forms/payout/forms/PayoutEstimatedDestinationAmountFormGroup.vue";
import PayoutInputAmountFormGroup from "@/components/forms/payout/PayoutInputAmountFormGroup.vue";
import PayoutEvaluateFeeFormGroup from "@/components/forms/payout/PayoutEvaluateFeeFormGroup.vue";
import PayoutFormGroupRegularWidth from "@/components/forms/payout/PayoutFormGroupRegularWidth.vue";
import PayoutCountriesDropdown
  from "@/components/forms/payout/forms/banks/PayoutCountriesDropdown.vue";

export default defineComponent({
  name: "WirePaymentForm",
  components: {
    PayoutCountriesDropdown,
    PayoutFormGroupRegularWidth,
    PayoutEvaluateFeeFormGroup,
    PayoutInputAmountFormGroup,
    PayoutEstimatedDestinationAmountFormGroup,
    PayoutGroupVerificationType,
    PayoutFormNotificationBlock,
    PayoutFormGroupSectionCheckbox,
    SwiftSelector,
    ErrorMessageBlock,
    PayoutTextfieldInputGroup,
    PayoutToggableHintPanelFormGroup,
    PayoutHintPanelFormGroup, PayoutToggableHintPanel, DropdownKeyvalue, PayoutFormGroup},
  extends: AbstractPayoutForm,
  setup() {
    const model = reactive(new WirePaymentModel());

    const tagOptions = computed(() => {
      const sourceAccount = model.getSourceAccount();
      if (sourceAccount && (sourceAccount.currency == CurrencyCode.EUR)) {
        return [WireTagEnum.SHA];
      }

      return model.loaded ? Object.keys(model.options.tags) : [
        WireTagEnum.SHA,
        WireTagEnum.OUR,
        WireTagEnum.BEN
      ];
    });

    const beneficiaryCountryLimit = computed(() => {
      return (model.options.beneficiaryCountriesData || []).map((country) => country.alpha2);
    });

    const tagOptionsKeyValue = computed(() => {
      const i18n = getCurrentInstance()?.proxy.$i18n as VueI18n;
      const result = {};
      tagOptions.value.forEach((tag) => {
        result[tag] = i18n ? i18n.t(`wire_tag.${tag}`) : tag;
      });
      return result;
    });

    const warningEurSha = computed(() => {
      const sourceAccount = model.getSourceAccount();
      return sourceAccount && (sourceAccount.currency == CurrencyCode.EUR) /*&& (model.values.tag == WireTagEnum.SHA)*/;
    });

    watch(() => model.values.tag + '-' + model.getSourceAccount()?.currency, (value) => {
      if (model.getSourceAccount()?.currency == CurrencyCode.EUR)
        model.values.tag = WireTagEnum.SHA;
    })

    const beneficiaryAddressCountries = computed(() => {
      return model.loaded ? model.options.beneficiaryCountriesData : [];
    });
    const bankAddressCountries = computed(() => {
      return model.loaded ? model.options.bankCountriesData : [];
    });

    const beneficiaryAddressCountriesSorted = computed(() => {
      const result = {};
      const lang = getCurrentInstance()?.proxy.$i18n.locale ?? 'en';
      const langKey = 'name' + lang[0].toUpperCase() + lang[1];
      beneficiaryAddressCountries.value.sort((a, b) => {
        if (!(langKey in a) || !(langKey in b)) {
          return 0;
        }
        return a[langKey].localeCompare(b[langKey]);
      }).forEach((country) => {
        result[country.nameEn + '-' + country.alpha2] = (lang == 'ru' ? country.longNameRu : country.longNameEn) + ' (' + country.alpha2 + ')';
      });
      return result;
    });

    const bankAddressCountriesSorted = computed(() => {
      const result = {};
      const lang = getCurrentInstance()?.proxy.$i18n.locale ?? 'en';
      const langKey = 'name' + lang[0].toUpperCase() + lang[1];
      bankAddressCountries.value.sort((a, b) => {
        if (!(langKey in a) || !(langKey in b)) {
          return 0;
        }
        return a[langKey].localeCompare(b[langKey]);
      }).forEach((country) => {
        result[country.nameEn] = (lang == 'ru' ? country.longNameRu : country.longNameEn) + ' (' + country.alpha2 + ')';
      });
      return result;
    });

    const beneficiaryBankSWIFT = ref('');

    const onBankSelected = (bank) => {
      model.values.beneficiaryBankSWIFT = bank.code;
      model.values.beneficiaryBankName = bank.bankName;
      model.values.beneficiaryBankCountry = bank.country;
      model.values.beneficiaryBankAddress = bank.city;
    }

    const onCorrBankSelected = (bank) => {
      model.values.correspondentBankSWIFT = bank.code;
      model.values.correspondentBankName = bank.bankName;
      model.values.correspondentBankCountry = bank.country;
      model.values.correspondentBankAddress = bank.city;
    }

    watch(() => model.values.correspondentBank, (value) => {
      if (!value) {
        model.values.correspondentBankAddress = '';
        model.values.correspondentBankSWIFT = '';
        model.values.correspondentBankName = '';
        model.values.correspondentBankCountry = '';
        model.values.correspondentAccount = '';
      }
    });

    return {
      onBankSelected,
      onCorrBankSelected,
      model,
      beneficiaryBankSWIFT,
      tagOptions,
      tagOptionsKeyValue,
      warningEurSha,
      bankAddressCountries,
      beneficiaryAddressCountries,
      beneficiaryAddressCountriesSorted,
      bankAddressCountriesSorted,
      beneficiaryCountryLimit
    }
  }
})
</script>

<style scoped>

</style>

<i18n>
{
  "ru": {
    "wire_tag": {
      "SHA": "Раздельная комиссия (SHA)",
      "BEN": "Комиссия на получателе (BEN)",
      "OUR": "Комиссия на отправителе (OUR)",
      "description": {
        "BEN": "Получатель оплачивает комиссию банка и других банков, вовлеченных в перечисление. Комиссия удерживается из суммы перечисления.",
        "SHA": "Комиссия разделена между отправителем и получателем. Комиссия удерживается из суммы перечисления.",
        "OUR": "Отправитель оплачивает комиссию банка и других банков, вовлеченных в перечисление. Комиссия удерживается из суммы перечисления."
      }
    },
    "warning_eur_sha": "Для переводов в {CUR} доступен только тип {TAG} (Раздельная комиссия).",
    "description_hint": "Назначение платежа должно содержать наименование оплачиваемого товара/услуги, номер и дату инвойса или договора."
  },
  "en": {
    "Тип перевода": "Transfer type",
    "Выберите тип перевода": "Select transfer type",
    "wire_tag": {
      "SHA": "Separate commission (SHA)",
      "BEN": "Commission to the recipient (BEN)",
      "OUR": "Commission to the sender (OUR)",
      "description": {
        "BEN": "The recipient pays the bank commission and other banks involved in the transfer. The commission is deducted from the transfer amount.",
        "SHA": "The commission is divided between the sender and the recipient. The commission is deducted from the transfer amount.",
        "OUR": "The sender pays the bank commission and other banks involved in the transfer. The commission is deducted from the transfer amount."
      }
    },
    "warning_eur_sha": "For transfers in {CUR} only {TAG} (Separate commission) is available.",
    "Раздельная комиссия (SHA)": "Separate commission (SHA)",
    "Получатель": "Beneficiary",
    "Имя получателя": "Beneficiary name",
    "Адрес получателя": "Beneficiary address",
    "SWIFT-код банка": "SWIFT code",
    "Страна": "Country",
    "Выберите страну": "Select country",
    "Адрес банка": "Bank address",
    "Банковские реквизиты": "Bank details",
    "Назначение": "Description",
    "Банк-корреспондент": "Correspondent bank",
    "Страна банка": "Bank country",
    "Корр. счет": "Corr. account",
    "Название банка получателя": "Beneficiary bank name",
    "Адрес банка получателя": "Beneficiary bank address",
    "SWIFT-код банка получателя": "Beneficiary bank SWIFT code",
    "Cчет / IBAN получателя": "Beneficiary account / IBAN",
    "description_hint": "The payment purpose must contain the name of the paid product/service, invoice or contract number and date."
  }
}
</i18n>
